import React from 'react';
import { db } from '../services/firebase';
import moment from 'moment';
import { Layout, Button, Row, Col, Space, Input, InputNumber, Upload, message, Table } from 'antd'
import { LoadingOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import firebase from 'firebase';
import { watcherCotizaciones } from '../services/firebase/watcher'
import Modal from 'antd/lib/modal/Modal';

const { TextArea } = Input;
const { Content } = Layout;

const Vehicles = () => {
    //verificacion
    const [edit, setEdit] = React.useState(false)
    //crud
    const [id, setId] = React.useState(null)
    const [imageurl, setImageurl] = React.useState('')
    const [loading, setLoading] = React.useState(false)
    const [uploadValue, setUploadValue] = React.useState(1)
    const [vehiculos, setVehiculos] = React.useState([])
    const [marca, setMarca] = React.useState('')
    const [modelo, setModelo] = React.useState('')
    const [precio, setPrecio] = React.useState(1)
    const [vehiculo, setVehiculo] = React.useState({})
    const [pagination, setPagination] = React.useState({
        current: 1,
        pageSize: 10,
    })

    const handleEdit = registro => {
        console.log(registro.id)
        setEdit(true)
        setId(registro.id)
        setMarca(registro.marca)
        setModelo(registro.modelo)
        setPrecio(registro.precio)
        setImageurl(registro.logo)
    }



    const columns = [
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha',
            render: (text, record) => (
                <p>{moment(record.fecha.toDate()).format('DD/MM/YYYY hh:mm')}</p>
            )
        },
        {
            title: 'Lada',
            dataIndex: 'lada',
            key: 'lada',
        },
        {
            title: 'Telefono',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Correo',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: "Acciones",
            key: "action",
            render: (text, record) => (
                <Space direction='horizontal'>
                    <Button ghost type='danger' onClick={() => db.collection('cotizaciones').doc(record.id).delete().then(message.success('Registro eliminado con exito'))}>Quitar</Button>
                </Space>
            )
        }
    ];

    const handleTableChange = (pagination, filters, sorter) => {
        setPagination(pagination)
    };



    React.useEffect(() => {
        watcherCotizaciones(c => {
            setVehiculos(c)
        })
    }, []);

        const aggclub = async () => {
            let vehiculo = {
                marca: marca,
                modelo: modelo,
                precio: precio,
                logo: imageurl,
            };

            if (edit === true) {
                await db.collection('vehiculos').doc(id)
                    .set(vehiculo).then(() => {
                        message.success('Registro editado con exito')
                        setMarca('');
                        setModelo('');
                        setPrecio('');
                        setImageurl('');
                    })
            } else {
                await db.collection('vehiculos').add(vehiculo).then(() => {
                    message.success('Registro agregado con exito')
                    setMarca('');
                    setModelo('');
                    setPrecio('');
                    setImageurl('');
                })
            }
        }

        function beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                return message.error('Solo puedes subir archivos JPG o PNG!');
            }
            const isLt5M = (file.size / 1024 / 1024) < 2;
            if (isLt5M) {
                const storageRef = firebase.storage().ref(file.name);
                const task = storageRef.put(file);

                task.on('state_changed', (snapshot) => {
                    let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    setUploadValue(percentage);
                }, (error) => {
                    console.error(error.message)
                }, () => {
                    // Upload complete
                    setImageurl(task.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                        setImageurl(downloadURL)
                    }))
                    setLoading(false)
                })
            } else {
                message.error('El logo que intentas subir pesa mas de 2MB')
                setLoading(false)
            }
        }

        const handleChange = info => {
            //info.preventDefault()
            if (info.file.status === 'uploading') {
                setLoading(true)
                return;
            }
            //if (info.file.status === 'done') {
            //  // Get this url from response in real world.
            //  getBase64(info.file.originFileObj, imageUrl =>
            //    setImageurl(imageUrl),
            //    setLoading(false)
            //  );
            //}
        };

        const uploadButton = (
            <div>
                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div style={{ marginTop: 8 }}>Upload</div>
            </div>
        );

        return (
            <Layout>
                <Content
                    className="site-layout-background"
                    style={{
                        padding: 24,
                        margin: 0,
                        minHeight: 600,
                    }}
                >
                    <h1>WTI Services - Cotizaciones</h1>
                    <Table
                        dataSource={vehiculos}
                        columns={columns}
                        size='small'
                        pagination={pagination}
                        onChange={(a, b, c) => handleTableChange(a, b, c)}
                    />
                </Content>
            </Layout>
        )
    }

export default Vehicles


// WEBPACK FOOTER //
// ./src/pages/Cotizaciones.jsx